import React from "react";
import type { DbTimeString } from "@openings/api-client";
import {
  timeButtonSelectedStyle,
  timeButtonStyle,
} from "../bookingStyles";

interface TimeButtonProps {
  onClick: () => void;
  time: DbTimeString;
  label?: string;
  isSelected?: boolean;
}

const HOVER_STYLE = `
  .openings-time-btn:hover:not([aria-pressed="true"]) {
    background: var(--openings-color-surface-hover, #f5f5f5) !important;
    border-color: var(--openings-booking-time-hover-border, #ccc) !important;
  }
  .openings-time-btn[aria-pressed="true"],
  .openings-time-btn:active {
    background: var(--openings-booking-time-selected-bg, var(--openings-color-primary, #111)) !important;
    border-color: var(--openings-booking-time-selected-border, var(--openings-color-primary, #111)) !important;
    color: var(--openings-booking-time-selected-text, var(--openings-color-primary-text, #fff)) !important;
    box-shadow: var(--openings-booking-time-selected-shadow, none);
  }
  .openings-time-btn:focus-visible {
    outline: 2px solid var(--openings-color-text, #111);
    outline-offset: 2px;
  }
`;

const TimeButton = ({
  onClick,
  time,
  label,
  isSelected,
}: TimeButtonProps) => {
  return (
    <>
      <style>{HOVER_STYLE}</style>
      <button
        type="button"
        className="openings-time-btn"
        onClick={onClick}
        aria-pressed={isSelected}
        style={
          isSelected === true
            ? { ...timeButtonStyle, ...timeButtonSelectedStyle }
            : timeButtonStyle
        }
      >
        {label ?? time}
      </button>
    </>
  );
};

export default TimeButton;
